import React from 'react'
import { Typography, withStyles } from '@material-ui/core'

import theme from 'theme'
import { useIsMobile } from 'utils/hooks'

const LOGO_IMAGE_RATIO = 32 / 7

const TextLogo = ({ classes }) => (
  <img
    src="/logo.svg"
    alt="logo"
    className={classes.image}
    width={theme.spacing(7) * LOGO_IMAGE_RATIO}
    height={theme.spacing(7)}
  />
)

const IconLogo = ({ classes }) => {
  const isMobile = useIsMobile()
  return (
    <img
      src={isMobile ? '/logo.svg' : '/logo-icon.svg'}
      alt="logo"
      className={classes.image}
      width={theme.spacing(7) * LOGO_IMAGE_RATIO}
      height={theme.spacing(7)}
    />
  )
}

export const ICON_VARIANT = 'icon'
export const TEXT_VARIANT = 'text'

const Logo = ({ variant = 'text', classes, className }) => {
  return (
    <Typography variant="h6" color="inherit" className={className}>
      <a href="/" className={classes.link} title="Go to homepage">
        {variant === TEXT_VARIANT && <TextLogo classes={classes} />}
        {variant === ICON_VARIANT && <IconLogo classes={classes} />}
      </a>
    </Typography>
  )
}

const styles = {
  link: {
    color: 'inherit',
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
  },
  image: {
    height: theme.spacing(5),
    [theme.breakpoints.up('sm')]: {
      height: theme.spacing(7),
    },
  },
}

export default withStyles(styles)(Logo)
